// extracted by mini-css-extract-plugin
export default {"form":"UploadItemsForm_form__G1H-G","imageUpload":"UploadItemsForm_imageUpload__+iJAB","buttonItem":"UploadItemsForm_buttonItem__vwac4","button":"UploadItemsForm_button__reFDz"};